import { render, staticRenderFns } from "./OtherStat.vue?vue&type=template&id=27b21721&scoped=true&"
import script from "./OtherStat.vue?vue&type=script&lang=js&"
export * from "./OtherStat.vue?vue&type=script&lang=js&"
import style0 from "./OtherStat.vue?vue&type=style&index=0&id=27b21721&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b21721",
  null
  
)

export default component.exports